<template>

  <v-dialog
    v-model="show"
    persistent
    fullscreen
    >
    <div style="background: #f0f0f0; padding: 6px; min-height: 100%;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{action=='new'?'New':'Modify'}} Sales </span>
            <v-spacer/>
            <v-btn  @click="emitToParent('close')" fab x-small elevation="1" color="warning"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
    <v-row no-gutters>
      <v-col cols="12" sm="5">
        <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
          <v-card class="ma-1">
            <v-card-text>
              <div>
                <span class="font-weight-bold lg-font" style="float:right">{{sales.type}}</span>
                <span class="font-weight-bold lg-font">Number: {{sales.id}}</span>
                <a :href="'/view-job/' + sales.id" target="_blank" rel="noopener noreferrer"><v-icon right small color="info">mdi-open-in-new</v-icon></a>
                 <v-divider class="mb-4"/>
              </div>
            Customer Details
              <v-divider class="mb-4"/>
              <v-autocomplete
              v-model="sales.customer_id"
              :items="customers"
              filled
             
              color="blue-grey lighten-2"
              label="Select Customer"
              item-text="fullname"
              :rules="textRules"
              :disabled="action!='new'"
              item-value="id"
              hide-details
            >
            
              <template v-slot:item="data">
                  <div class="va-drop-list">
                     {{data.item.fullname}}
                      <br />
                     <span class="md-font font-italic text-info font-weight-thin"> Mobile: {{data.item.mobile}}</span>
                  </div>
              </template>
            </v-autocomplete>
            <a class="md-font font-italic text-info" v-if="action=='new'" @click="customer_state='new',cusform=true">
              <v-icon left small color="info">mdi-plus</v-icon>New Customer</a>
            <p class="mt-2" v-if="action!='new'"> Mobile: {{sales.customer_data.mobile}}</p>
            <div class="mt-4">Sales Details</div> 
            <v-divider class="mb-6"/>
              <v-row >
                
                <v-flex class="pa-2">
                  <v-autocomplete
                    v-model="sales.type"
                    outlined
                    :rules="textRules"
                    hide-details
                    dense
                    :disabled="sales.status =='Completed'"
                    :items="sales_types"
                    label="Sales Type"
                  />
                </v-flex>
                <v-flex class="pa-2">
                  <v-text-field
                    v-model="sales.invoice_no"
                    outlined
                    hide-details
                    :disabled="sales.status =='Completed'"
                    dense
                    label="Invoice No."
                  />
                </v-flex>
                <v-flex class="pa-2" v-if="saleprops('Rental,Subscription,Installment')">
                    <v-autocomplete
                          v-model="sales.payment_frequency"
                          outlined
                          hide-details
                          :items="payment_frequencies"
                          dense
                          label="Payment Frequency"
                        />
                  </v-flex>
                  <v-flex class="pa-2" v-if="saleprops('Rental,Subscription,Installment')">
                    <v-text-field
                       v-model="sales.payment_length"
                        outlined
                        type="number"
                        dense
                        hide-details
                        label="Payment Length"
                      />
                  </v-flex>
                  <v-flex class="pa-2" v-if="saleprops('Rental,Subscription,Installment')">
                    <v-text-field
                       v-model="sales.due_amount"
                        outlined
                        hide-details
                        dense
                        label="Due Amount"
                      />
                    </v-flex>
                    <v-flex class="pa-2" v-if="saleprops('Rental,Subscription,Installment')">
                           <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="sales.due_date"
                                       :rules="FieldRules('Date is required.')"
                                      label="Due Date"
                                    dense
                                    outlined
                                      readonly
                                      hide-details
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="sales.due_date"
                                    no-title
                                    scrollable
                                    @input="menu = false"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                    </v-flex>
                    <v-flex class="pa-2" v-if="saleprops('Rental,Subscription,Installment,Drop Ship,Pre-order')">
                    <v-text-field
                        v-model="sales.init_payment"
                        outlined
                        hide-details
                        type="number"
                        dense
                        label="Initial Amount"
                      />
                    </v-flex>
                     <v-flex class="pa-2" v-if="saleprops('Job Order')">
                      <v-autocomplete
                      v-model="sales.service_bay"
                          outlined
                          hide-details
                          :items="service_bays"
                          item-text="name"
                          item-value="name"
                          dense
                          label="Service Bay"
                        />
                    </v-flex>
                    <v-flex class="pa-2" v-if="saleprops('Drop Ship')">
                      <v-autocomplete
                      v-model="sales.payment_terms"
                          outlined
                          hide-details
                          :items="GET_SYSVARS('payment_terms')"
                          dense
                          label="Payment Terms"
                        />
                    </v-flex>
                    <v-flex class="pa-2" v-if="saleprops('Drop Ship')">
                      <v-text-field
                        outlined
                        hide-details
                        dense
                        label="Shipping Method"
                      />
                    </v-flex>
                    <!-- <v-flex class="pa-2" v-if="saleprops('Drop Ship')">
                      <v-text-field
                        outlined
                        hide-details
                        dense
                        label="Shipping Terms"
                      />
                    </v-flex> -->

                    
                 
              </v-row>
              <v-divider class="mt-4 mb-4" />
              <v-row v-if="action=='modify'">
                  
                  <v-col cols="6">Remarks: <br /><span class="font-weight-bold lg-font">{{sales.remarks}}</span> </v-col>
                  <v-col cols="3">Status: <br /><span class="font-weight-bold lg-font">{{sales.status}}</span> </v-col>
                  <v-col cols="3">Payment: <span v-if="sales.payment_status=='Paid'">{{ sales.payment_method }}</span> <br /><span class="font-weight-bold lg-font">{{sales.payment_status}}</span></v-col>
              </v-row>
              
              <v-divider class="mt-4 mb-4" />
              <div>
              <v-btn class="ma-2"
               v-if="sales.type=='Job Order' && sales.status=='Pending' && ALLOWEDACTION('accept_job')"
                color="primary"
                 @click="sales.status='In Progress', sales.remarks='Assigned to our team', UpdateLog('Job Order is now assigned to our team')" 
                >
               Job Order Accept
              </v-btn>
               <v-btn class="ma-2"
               v-if="sales.type=='Job Order' && sales.status=='For Inspection' && ALLOWEDACTION('complete_job')"
                color="success"
                 @click="complete()" 
                >
               Job Order Complete
              </v-btn>
              <v-btn class="ma-2"
               v-if="sales.status!='Completed' && sales.status!='Cancelled' && action !='new' "
                color="warning"
                 @click="cancel()" 
                >
               Cancel
              </v-btn>
               <v-btn class="ma-2"
               v-if="sales.payment_status=='Unpaid' && sales.status!='Completed' && sales.status!='Cancelled'"
                color="secondary"
                 @click="cpform=true" 
                >
               Paid
              </v-btn>
               
                <!-- <v-btn  class="ma-2">For Inspection</v-btn>
               
                <v-btn  class="ma-2">Completed</v-btn> -->
             </div>   
             </v-card-text> 
             
          </v-card>
          </v-form>
          <div class="pa-2">
            <p class="pa-1 ma-0">Media Files</p>
            <v-divider class="mb-2"/>
            <span v-if="sales.files !='' ">
                   <img 
                   width="150"
                   class="imgview"
                   @click="imgsrc = img, imgview=true"
                  v-for="(img,m) in sales.files"
                  :key="m +'-fm'"
                   :src="img">
            </span>
          </div>
           
           
          <div class="ma-1" v-if="action=='modify' && sales.status=='In Progress'">
          
              <zera-s3-upload :show="s3upload" @zeraEvent="s3Ev"/>
          </div>
         
          
      </v-col>
      <v-col cols="12" sm="7">
          <v-card class="ma-1">
            <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-btn text small color="info" @click="finder=true"  v-if="CAN_ENTRY"><v-icon left >mdi-plus</v-icon>ADD ITEM </v-btn>
            <v-divider vertical/>

          </v-toolbar>
              <v-card-text>
                <table class="va-table va-table-border-bot">
                  <tr>
                    <th width="32"></th>
                    <th>Item</th>
                    <th>Description</th>
                    <th class="text-center" width="120">QTY</th>
                    <th class="text-right">Sales Price</th>
                    <th class="text-right">Amount</th>
                  </tr>
                  <tr  v-for="(item, index) in sales_items" :key="index+'-l'">
                    <td class="text-center"><v-icon v-if="CAN_ENTRY" color="error" @click="removeItem(index)">mdi-close-circle</v-icon></td>
                    <td><span class="font-weight-bold">{{ item.name }}</span>
                        <br/><span class="font-italic def-font text-info" v-if="item.code!='null'">code: {{ item.code }}</span>
                    </td>
                     <td>
                    
                      <p class="ma-1">{{ item.description }}</p>
                        <p class="ma-1 def-font" v-for="(_prop, _index) in item.properties" :key="_index+'-p'">{{_prop.name}} : {{_prop.value}} </p>
                    </td>
                    <td class="text-center">
                        <input v-if="CAN_ENTRY" type="number" v-model="item.quantity" @change="item.quantity = $IsNum(item.quantity)" class="_qty" /> 
                        <span v-else>{{item.quantity}}</span>
                        <span v-if="item.quantity>item.stock" class="def-font text-warning font-italic">
                          <br>
                            <span v-if="item.track =='Track Inventory'">Note: Quantity to purchase is higher than the current stock.</span>
                        </span>                 
                    </td>
                    <td class="text-right">{{ $money(item.selling_price )}}</td>
                    <td class="text-right">{{ $money(item.amount * item.quantity )}}</td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td class="text-right" colspan="5">SUB-TOTAL:</td>
                    <td class="text-right">{{$money(SUBTOTAL)}}</td>
                  </tr>
                  <tr class="font-weight-bold" v-if="TAXES">
                    <td class="text-right" colspan="5">TAX:</td>
                    <td class="text-right">{{$money(TAXES)}}</td>
                  </tr>
                   <tr class="" v-if="DISCOUNT">
                    <td class="text-right" colspan="5">Discounts</td>
                    <td class="text-right"></td>
                  </tr>
                   <tr class="text-warning"  v-for="(discount, index) in sales.discount_items" :key="index+'-ad'">
                    <td class="text-right" colspan="5">{{ discount.name }}</td>
                    <td class="text-right">- {{$money(discount.amount)}}</td>
                  </tr>
                  <tr class="font-weight-bold text-h6">
                    <td class="text-right" colspan="5">TOTAL:</td>
                    <td class="text-right">{{$money(TOTAL)}}</td>
                  </tr>
                </table>
                <template  v-if = "sales.payment_status != 'Paid'">
                <p>
                <v-checkbox
                  v-if="sales.discount_request != 'Approved'"
                  dense
                  v-model="sales.discount_request"
                  label="Request For Discount"
                  color="info"
                  value="Request For Discount"
                  hide-details
                ></v-checkbox>
                </p>
                 <zera-custom-fields  title="Add Discount" icon="mdi-plus"
                            v-if="ALLOWEDACTION('add_sales_discount')"
                            :params="[
                              {value: '', type:'',label: 'Name'}, {value: '', type:'number',label: 'Discount Amount'}, 
                            ]" 
                            @CFEvent="discEv"/>

                </template>            
              </v-card-text>
              
          </v-card>
          <div class="ma-1">
            <v-bottom-navigation>
              <v-btn value="recent"   @click="emitToParent('close')">
                <v-icon>mdi-close</v-icon>

                <span>Close</span>
              </v-btn>

              <v-btn value="favorites"  @click="printView()"> 
                <v-icon>mdi-printer</v-icon>

                <span>Print</span>
              </v-btn>

              <v-btn v-if="CAN_ENTRY" :loading="loading" color="success" @click="loading=true,validate()">
                <v-icon color="white">mdi-disc</v-icon>
                <span class="text-white">{{action=='new'?'Add':'Update'}} Sales</span>
              </v-btn>
            </v-bottom-navigation>
          </div>  

           <div class="ma-1 mt-4" v-if="action=='modify'">
              <widgets-service-logs :sales="sales" :show="activity"/>
          </div>
        </v-col>

    </v-row>      

  
  </div>
    <va-confirm :show="confirm.show" :message="confirm.message"  :cancelbtn="confirm.cancelbtn" :okbtn="confirm.okbtn" @ConfirmEvent="confirmEvent" />
    <va-confirm-payment :show="cpform" :data="sales" @DialogEvent="cpEv"/>
    <va-customer-form :show="cusform" :state="customer_state" @DialogEvent="formEv"/>
    <va-product-finder :show="finder"  @DialogEvent="finderEv"/>
     <va-status-dialog :show="statusDialog" :sales="sales" @DialogEvent="statEv"/>
     <zera-image-viewer :show="imgview" :imgsrc="imgsrc" @DialogEvent="imgview = false"/>
  </v-dialog>
</template>

<script>

export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      confirm: {
        message:"",
        cancelbtn: "Close",
        okbtn: "OK",
        action:"",
        show: false
      },
      action:"",
      menu:false,
      cpform: false,
      imgview: false,
      imgsrc:"",
      newcustomer: false,
      activity: false,
      job_remarks:"",
      valid: true,
      statusDialog: false,
      loading: false,
      discount_request:"",
      customer_state: "new",
      cusform: false,
      finder: false,
      customers:[],
      s3upload: false,
      newpassword:'',
      show1: false,
      sales_items:[],
      sales: {customer_data: {mobile:""}},
      tax:0,
      sales_types:[],
      service_bays:[],
      payment_frequencies:[],
       textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      CAN_ENTRY() {
         if(this.sales.status=='Completed' || this.sales.status=='Cancelled' || this.sales.payment_status=='Paid') {
          return false
         } else {
          return true
         }
      },
      SUBTOTAL() {
        var total =this.sales_items.reduce((res,item)=>{
          res = this.$IsNum(res) + (this.$IsNum(item.selling_price)* this.$IsNum(item.quantity))
            return res
        },0)
        return total
      },
       TAXES(){
          var tax = this.$IsNum(this.tax/100)
          if(this.sales.payment_status == "Paid") {
            return this.$IsNum(this.sales.tax)
          }
        return this.$IsNum(this.SUBTOTAL * tax)
      },
       DISCOUNT(){
       
        return this.$IsNum(this.sales.discount)
      },
       TOTAL(){
        if(this.saleprops('Rental,Subscription,Installment')) {
             return this.$IsNum(this.sales.payment_length) * this.$IsNum(this.sales.due_amount)
        } else {
            return this.$IsNum(this.SUBTOTAL + this.TAXES) - this.$IsNum(this.DISCOUNT)
        }
        
      },
     
  },
  watch: {
    show (v) {
      if (v) {
          this.sales_types =  this.GET_SYSVARS('sales_order_types')
          this.payment_frequencies =  this.GET_SYSVARS('payment_frequencies')
          this.tax =  this.$IsNum(this.GET_SYSVARS('tax'))
          this.sales_items = []
          
          this.action = this.state
          this.getCustomers()
          this.activity=false
           this.s3upload = false
           this.getServiceBay()
          if(this.state == 'modify') {
            this.s3upload = true
            this.getSales(this.selectedID)
          } else {
            this.sales.due_date = this.$moment().add(1, 'month').format("YYYY-MM-DD")
          }
      } else {
        this.sales = {customer_data: {mobile:""}}
      }
    }
  },
  methods: {
     getServiceBay(){
          this.service_bays = []
          this.QUERY('sales',`select * from service_bays order by id asc`, (res)=>{
              this.service_bays = res.results    
          })
      }, 
    printView(){
      var  route = this.$router.resolve({
       path: "/print-view/"+this.sales.id
      });
    window.open(route.href, "_blank");
    },
    complete(){
      if(this.sales.payment_status != "Paid") {
           this.confirm = {
        message:"Please proceed to payment!",
        cancelbtn: "Close",
        okbtn: "Ok",
        action:"payment required",
        show: true
      }
      return
      }
     this.confirm = {
        message:"Job Order " + this.sales.id + ' is completed?',
        cancelbtn: "Close",
        okbtn: "Confirm",
        action:"Complete",
        show: true
      }
    },
    cancel(){
     this.confirm = {
        message:"Cancel sales " + this.sales.id + '?',
        cancelbtn: "Close",
        okbtn: "Confirm and cancel",
        action:"Cancel",
        show: true
      }
    },
    _resetConfirm(){
      this.confirm = {
        message:"",
        cancelbtn: "Close",
        okbtn: "OK",
        action:"",
        show: false
      }
    },
    confirmEvent(e){
      if(e=='ok') {
          if(this.confirm.action == 'Cancel') {
            this.sales.status = "Cancelled"
             this.sales.remarks='Sales has been cancelled'
            this.sales.payment_status='Unpaid'
            console.log("to cancel", this.sales)
            this.Update()
             setTimeout(()=>{
              this.PostLog('Sales has been cancelled!')
              this._resetConfirm()
            },500)
          } else if(this.confirm.action == 'Complete') {
            this.sales.status='Completed'
            this.sales.remarks='Job Order Completed'
            this.Update()
             setTimeout(()=>{
              this.PostLog('Job Order is now completed.')
              this._resetConfirm()
            },500)
          } else {
             this._resetConfirm()
          }
      } else {
         this._resetConfirm()
      }
    },
    cpEv(e){
        this.cpform=false
        this.loading=false
        if(e == 'confirmed'){
            this.PostLog("Received and confirm payment.")
            setTimeout(()=>{
              if(this.sales.type== 'Job Order') {
                  this.getSales(this.selectedID)
              } else {
                this.emitToParent()
              }
                 
            },1000)
        } else {
         setTimeout(()=>{
            this.emitToParent()
         },500)
            
        }
    },
    s3Ev(array_images){
      if(this.sales.files == null) {
        this.sales.files = array_images
      } else {
        this.sales.files = this.sales.files.concat(array_images)
      }
      this.validate()
      setTimeout(()=>{ this.PostLog("New images has been uploaded") },1300)
      
      },
    statEv(id){
     this.statusDialog = false
     this.getSales(id)
    },
    validate(){
       if (this.$refs.form.validate()) {
           
            this.sales.product_items = this.sales_items
            this.sales.sales_person = this.$IsNum(this.$session.get('userID'))
            this.sales.status = "Pending"
            this.sales.total_amount = this.$IsNum(this.TOTAL)
            this.sales.discount = this.$IsNum(this.DISCOUNT)
            this.sales.sales_amount = this.$IsNum(this.SUBTOTAL)
            this.sales.tax = this.$IsNum(this.TAXES)
            this.sales.customer_data= this.setCustomer()
            if(this.saleprops('Rental,Subscription,Installment')) {
                this.sales.payment_length = this.$IsNum(this.sales.payment_length)
                 this.sales.init_payment = this.$IsNum(this.sales.init_payment)
            this.sales.due_amount = this.$IsNum(this.sales.due_amount)
            this.sales.due_date = this.$moment(this.sales.due_date).format("YYYY-MM-DD")
            }
            
             if(this.action=='new') {
              if(this.IsEmpty(this.sales.product_items) || this.sales.product_items.length==0) {
                this.loading = false
                this.VA_ALERT('error', 'Please add at least one item to sales.', 'close', 500, 2000)
                return
              }
               this.sales.payment_status="Unpaid"
              this.Add()
            } else {
              this.Update()
            }
            
        } else {
          this.loading = false
        }
    },
    sumDiscount(discounts){
        var total = discounts.reduce((res,item)=>{
              res = this.$IsNum(res) + this.$IsNum(item.amount)
            return res
        },0)
        
        return total
    },
      discEv(item){
     
         var newitem = {
            name: item[0].value,
             amount: this.$IsNum(item[1].value),
          }
        if(this.IsEmpty(this.sales.discount_items)) {
          this.sales.discount_items = [newitem]
        } else {
            this.sales.discount_items.push(newitem)
        }

        this.sales.discount = this.sumDiscount(this.sales.discount_items)
        console.log("discount:",  this.sumDiscount(this.sales.discount_items))
        if(this.sales.discount >0) {
           this.sales.discount_request = "Approved"
          this.validate()
          setTimeout(()=>{this.PostLog('Adding discount...')},500)
        }
       
      },
    removeItem(index){
      this.sales_items.splice(index,1)
    },
    finderEv(e){
      this.finder = false
      if(e!='close'){
          if(this.sales_items.length>0) {
            console.log("added", e)
            this.sales_items = this.sales_items.concat(e)
          } else {
            this.sales_items = e
          }
      }
    },
    formEv(){
      this.cusform=false
      this.newcustomer = true
       this.getCustomers()
    },
      saleprops(_types){
        if(!this.sales.type){
          return false
        }
        let typesArr = _types.split(',')
        for(var i=0; i<typesArr.length;i++) {
          if(this.sales.type == typesArr[i]){
            return true
          }
        }
      },
       PostLog(message){
         let nlog =  {
                "user": this.$session.get('fullname'),
                "message": this.Strip(message),
                "timestamp": this.$moment().format("YYYY-MM-DD hh:mm A")
            }
             if(this.sales.service_logs == null || this.sales.service_logs == "" || this.sales.service_logs == undefined) {
            this.sales.service_logs = [nlog]
        } else {
            this.sales.service_logs.push(nlog)
        }
    
           let params = {
            table: "sales", 
            type:"update",
            query:`update sales set  service_logs='${JSON.stringify( this.sales.service_logs)}'::jsonb where id=${this.sales.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        this.message = ""
        }).catch(e => {
          console.log(e.data)
        })
    },
       UpdateLog(message){
        var service_logs = []
        var log = {}
        log.timestamp =  this.$moment().format("YYYY-MM-DD hh:mm A")
        log.user =  this.$session.get('fullname')
        log.message = message
        
        if(this.sales.service_logs == null || this.sales.service_logs == "" || this.sales.service_logs == undefined) {
            service_logs.push(this.log)
            this.sales.service_logs = service_logs
        } else {
            this.sales.service_logs.push(log)
        }

            let params = {
            table: "product_items", 
            type:"update",
            query:`update sales set  status='${this.sales.status}',payment_status='${this.sales.payment_status}', remarks='${this.sales.remarks}', service_logs='${JSON.stringify(this.sales.service_logs)}' where id=${this.sales.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
           // this.emitToParent()
           setTimeout(()=>{ this.getSales(this.sales.id)}, 1000)
        }).catch(e => {
          console.log(e.data)
        })
    },
        Update(){
          console.log("update",  this.sales)
        this.$http.post("update_sales", this.sales).then(response => {
          console.log(response)
          this.loading=false
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 3000)
        
          this.sales = response.data.sale
          setTimeout(()=>{ this.getSales(this.sales.id)}, 1000)
        }).catch(e => {
          console.log(e.data)
        })
      },
      Add(){
        this.$http.post("add_sales", this.sales).then(response => {
          console.log(response)
          this.loading=false
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        
          this.sales = response.data.sale
          if(this.sales.type=='Job Order') {
              this.statusDialog = true
          } else {
              this.cpform=true
          }
          
        }).catch(e => {
          console.log(e.data)
        })
      },
      setCustomer(){
            var customer = this.customers.find(u => u.id === this.sales.customer_id);
            return customer
      },

      getCustomers(){
            this.QUERY('customers',`select id,  (profile->>'firstname') || ' ' || (profile->>'lastname') AS fullname, contact->>'mobile' as mobile from customers order by id desc`, (res)=>{
              if(res.status) {
                this.customers=res.results
                if(this.newcustomer) {
                  this.sales.customer_id = this.customers[0].id
                  setTimeout(()=>{
                    this.newcustomer = false
                  },1000)
                }
              }
             
            })
        
      },

       getSales(_salesID){
        console.log("getSales")

            this.QUERY('sales',`select * from sales where id=${_salesID}`, (res)=>{
              console.log(res)
              if(res.status) {
                this.sales=res.results[0]
                console.log("update sales",  this.sales)
                this.sales_items = this.sales.product_items
                this.action = "modify"
                this.activity = true
              }
             
            })
        
      },
     
    emitToParent () {
        this.$emit('DialogEvent', "")
    }
  }
}
</script>
